import { StreamActions } from '@hotwired/turbo';

StreamActions.animate_with_class = function () {
  const className = this.getAttribute('class');

  this.targetElements.forEach((e) => {
    e.classList.remove(className);

    // Find and temporarily remove all tailwind hover classes from this element
    // and all descendants so they don't interfere with our animation
    const elementsWithHover = [];

    // Check the target element itself
    const targetHoverClasses = Array.from(e.classList).filter(cls => /hover:/.test(cls));
    if (targetHoverClasses.length > 0) {
      elementsWithHover.push({ element: e, classes: targetHoverClasses });
      targetHoverClasses.forEach(cls => e.classList.remove(cls));
    }

    // Check all descendants
    const descendants = e.querySelectorAll('*');
    descendants.forEach(descendant => {
      const hoverClasses = Array.from(descendant.classList).filter(cls => /hover:/.test(cls));
      if (hoverClasses.length > 0) {
        elementsWithHover.push({ element: descendant, classes: hoverClasses });
        hoverClasses.forEach(cls => descendant.classList.remove(cls));
      }
    });

    window.requestAnimationFrame(() => {
      e.classList.add(className);

      // Restore all hover classes after animation completes
      const handleAnimationEnd = () => {
        elementsWithHover.forEach(({ element, classes }) => {
          classes.forEach(cls => element.classList.add(cls));
        });
        e.classList.remove(className);
        e.removeEventListener('animationend', handleAnimationEnd);
      };

      e.addEventListener('animationend', handleAnimationEnd);
    });
  });
};
